import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'

enum ModelTypes {
  PatientWithEvents = 'patient-with-event',
}

enum ModelTypeNames {
  PatientWithEvents = 'patientWithEvent',
}

export interface PatientWithEventsEvent {
  eventCategory: string
  eventFamily: string
  eventName: string
  eventTimestamp: number
  eventSeverity: number
  eventCode: number
  eventType: string | null
  // eventType: Optional<string>
  // eventLevel: Optional<string>
  // eventGroup: Optional<string>
  // patientId: Optional<string>
}

export interface PatientWithEventsAttributes {
  firstName: string
  lastName: string
  events: PatientWithEventsEvent[]
  timezone: string
  // starttimestamp: number
  // endtimestamp: number
  // resultStartTimestamp: number
  // resultEndTimestamp: number
}

export interface PatientWithEventsSchema {
  id: string
  attributes: PatientWithEventsAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.PatientWithEvents]: {
      attributes: {
        firstName: { type: 'string' },
        lastName: { type: 'string' },
        events: { type: 'array' },
        timezone: { type: 'string' },
      },
    },
  },
}

export async function getPatientWithEventsQuery() {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record for patient with events')
      return q.findRecords(ModelTypes.PatientWithEvents)
    })
    .catch(() => {
      console.log('fetch failed in patients with events')
    })
}

export async function getPatientWithEventsByIdQuery(patientId) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  console.log('Before calling find record for patient with events', patientId)
  return remote
    .query(q => q.findRecords(ModelTypes.PatientWithEvents).filter({ attribute: 'id', value: patientId }))
    .catch(() => console.log('fetch failed in patients with events', patientId))
}

function getPatientEventUniqueId(patientId, patientEvent: PatientWithEventsEvent) {
  return patientId + '_' + patientEvent.eventCode
}
// for localstorage
export function getPatientEventLastAddressedKey(patientId, patientEvent: PatientWithEventsEvent) {
  return 'patient_event_last_addressed_' + getPatientEventUniqueId(patientId, patientEvent)
}
export function isEventAddressed(patientId, patientEvent: PatientWithEventsEvent) {
  if (!patientEvent) return false
  let lastAddressed = localStorage.getItem(getPatientEventLastAddressedKey(patientId, patientEvent))
  if (!lastAddressed || !patientEvent) {
    return false
  }
  return parseInt(lastAddressed) >= patientEvent.eventTimestamp
}
